module.exports = __webpack_public_path__ + "img/user-icon.7ea4af7d.png";